import React, {Component} from 'react';
import {Steps} from 'antd';

const Step = Steps.Step;
const steps = [
  {
    title: '选择商品',
    content: '选择商品',
  },
  {
    title: '设置套餐信息',
    content: '设置套餐信息',
  },
  {
    title: '完成',
    content: '完成',
  }
];
class StepsModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0
    };
  }
  componentWillMount() {
    this.setState({currentStep: this.props.currentStep});
  }
  componentWillReceiveProps(props) {
    this.setState({currentStep: props.currentStep});
  }
  render() {
    return (
      <div>
        <Steps current={this.state.currentStep}>
          {steps.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
      </div>
    );
  }
}
export default StepsModel;



// WEBPACK FOOTER //
// ./src/components/backEnd/steps.jsx